"use client";
import { useEffect, useRef } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import Image from "next/image";
import Link from "next/link";

gsap.registerPlugin(ScrollTrigger);

const thirrdparty_images = [
    {
        image: "/images/partners/aws.png",
        link: "https://aws.amazon.com/partners/programs/"
    },
    {
        image: "/images/partners/clutchco.png",
        link: "https://clutch.co/profile/primalt/devops-managed-services-package"
    },
    {
        image: "/images/partners/goodfirmsco.png",
        link: "https://www.goodfirms.co/company/primalt"
    },
    {
        image: "/images/partners/googlereviews.png",
        link: "https://maps.app.goo.gl/zYQNZaaGzTqVsEkx6"
    },
];

export default function Party3rd() {
    const containerRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const items = containerRef.current?.querySelectorAll(".party-item");
        if (items) {
            items.forEach((el) => {
                gsap.from(el, {
                    opacity: 0,
                    y: 50,
                    duration: 1,
                    ease: "power3.out",
                    scrollTrigger: {
                        trigger: el,
                        start: "top 80%",
                    },
                });
            });
        }
    }, []);

    return (
        <div className="container mx-auto mb-12 mt-6 px-4 max-w-6xl">
            <div className="grid md:grid-cols-4 gap-8">
                {thirrdparty_images?.map((item, i) => (
                    <Link key={i} href={item.link} target="_blank" className="party-item bg-gradient-to-br content-center from-black-50/70 to-purple-900/50 border border-purple-900 p-6 rounded-lg shadow hover:shadow-lg transition hover:opacity-80">
                        <Image
                            src={item?.image}
                            alt={`screenshot`}
                            className="rounded-lg relative h-auto justify-self-center"
                            width={i == 0 ? 160 : (i == 2 ? 180 : 100)}
                            height={100}
                        />
                    </Link>
                ))}
            </div>
        </div>
    );
}
